module.exports = __webpack_public_path__ + "static/media/Galileo_playerDied.4127ae23.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_playerDied.wav
// module id = 191
// module chunks = 0